import React from "react";
import { Button } from "react-bootstrap";
import Modal from "./ThemedModal";
import type { ModalProps } from "./ThemedModal";
import { IoWarning } from "react-icons/io5";

export interface WarningModalProps extends Omit<ModalProps, "children"> {
	show: boolean;
	onHide: () => void;
	title?: React.ReactNode;
	body?: React.ReactNode;
	footer?: React.ReactNode;
}

const WarningModal: React.FC<WarningModalProps> = ({
	show,
	onHide,
	title,
	body,
	footer,
	...modalProps
}) => (
	<Modal show={show} onHide={onHide} {...modalProps}>
		<Modal.Header closeButton>
			<Modal.Title>
				<IoWarning className="me-2 mb-1" />
				{title || "Warning"}
			</Modal.Title>
		</Modal.Header>
		<Modal.Body>{body || <p>Are you sure you want to proceed?</p>}</Modal.Body>
		{footer && <Modal.Footer>{footer}</Modal.Footer>}
	</Modal>
);

export default WarningModal;
